import React from "react";
// import Layout from 'layout/index.js'

// import { Link } from 'react-router-dom';

import SearchIcon from '@mui/icons-material/Search';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';

import { authenticationService } from 'auth/authenticationService'
import {
          // Paper,
          Box,
          Button,
          Typography,
          Alert,
          TableSortLabel,TablePagination,TableContainer,Table,TableRow,TableHead,TableBody,TableCell,
          TextField

        } from '@mui/material';

const headCells = [
  { id: "traspasar", numeric: false,disablePadding: false,label: "", sorting: false},
  { id: "marca", numeric: false,disablePadding: false,label: "Marca", sorting: true},
  { id: "modelo", numeric: false, disablePadding: false, label: "Modelo", sorting: true},
  { id: "version", numeric: false,disablePadding: false,label: "Versión", sorting: true},
  { id: "cilindrada", numeric: false,disablePadding: false,label: "Cilindrada", sorting: true},
  { id: "equipamiento", numeric: false, disablePadding: false, label: "Equipamiento", sorting: true},
  { id: "equipamiento_detalle", numeric: false, disablePadding: false, label: "Equipamiento detalle", sorting: true},
  { id: "agno", numeric: false,disablePadding: false,label: "Año", sorting: true},
  { id: "tasacion", numeric: false,disablePadding: false,label: "Tasación", sorting: true},
  { id: "permiso", numeric: false, disablePadding: false, label: "Valor Permiso", sorting: true},
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          !headCell.sorting ? <TableCell key={headCell.id}>{headCell.label}</TableCell> : (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className='hideSort'>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
          )
        ))}
      </TableRow>
    </TableHead>
  );
}
function encodeQueryData(data) {
   const ret = [];
   for (let d in data)
     ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
   return ret.join('&');
}

class VehiculoSii extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

      objects: [],

      html: {
        list: true,
      },
      filters: {
        modelo:'',
        marca:'',
        agno:''
      },
      pagination:{
        page: 0,
        pages_num: 1,
        rows_num: -1,
        rows_per_page: 10,
      },
      sorting: {
        order_by:'marca',
        order:'desc',
      },
    };

    this.handleLoad = this.handleLoad.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleTraspasarModelo = this.handleTraspasarModelo.bind(this);
  }



  handleChangePage(event, page){
    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
          page: page,
      }}), ()=> this.handleLoad());

  }
  handleChangeRowsPerPage(event){
    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
          rows_per_page: event.target.value,
      }}), ()=> this.handleLoad());
  }

  handleSort(event, property){
    const isAsc = this.state.sorting.order_by === property && this.state.sorting.order === "asc";
    this.setState(prevState => ({
      sorting: {
          ...prevState.sorting,
          order: isAsc ? "desc" : "asc",
          order_by: property,
    }}),()=>this.handleLoad()
    );

  }


  handleLoad(){
    var params = {
        page: this.state.pagination.page+1,
        order_by: this.state.sorting.order_by,
        order: this.state.sorting.order,
        rows_per_page: this.state.pagination.rows_per_page
    };

    if(this.state.filters.modelo!=='' && this.state.filters.modelo){
      params['modelo'] = this.state.filters.modelo;
    }
    if(this.state.filters.marca!=='' && this.state.filters.marca){
      params['marca'] = this.state.filters.marca;
    }
    if(this.state.filters.agno!=='' && this.state.filters.agno){
      params['agno'] = this.state.filters.agno;
    }
    
    var query = encodeQueryData(params)

    authenticationService.fetchApi({
      url:'/permisos/vehiculo_sii/?'+query,
      method: 'GET',
    })
    .then(result=>{
      let list = false;
      if(result.data.length > 0){
        list=true;
      }
      this.setState(prevState => ({
        pagination: {
            ...prevState.pagination,
            rows_num: result.rows_num
        },
        html: {
          ...prevState.html,
          list: list,
        },
        objects: result.data
      }));
    })
    .catch(err=>{
      
    });
  }

  componentDidMount(){
    let modelo, marca, agno;
    if('modelo' in this.props){
      modelo = this.props.modelo;
    }
    else{
      modelo = '';
    }
    if('marca' in this.props){
      marca = this.props.marca;
    }
    else{
      marca='';
    }

    if('agno' in this.props){
      agno = this.props.agno;
    }
    else{
      agno='';
    }

    this.setState(prevState => ({
        filters: {
            ...prevState.pagination,
            modelo: modelo,
            marca: marca,
            agno: agno,
        },
    }),()=>{
      this.handleLoad();
    });
  
  }
  


  handleInputChange(event) {
    const { filters } = { ...this.state };
    const currentState = filters;
    const { name, value } = event.target;
    currentState[name] = value;

    this.setState({ filters: currentState },()=>{});
  }

  handleTraspasarModelo(event) {
    this.setState(prevState =>({ filters:{...prevState.filters,
      modelo: this.props.modelo_completo
    }
    }),()=>{});
  }
  render() {
    return (
        <Box>

          <Box p={1}>
            <Typography variant='h5'>
              Tasación de Vehiculos SII
            </Typography>
          </Box>
          <Box>

          <Box p={1}>
              <TextField  name='marca'
                          id='marca'
                          label={'Marca (Valor ficha: '+ (this.props.marca?this.props.marca:null) +')'}
                          placeholder={'Marca (Valor ficha: '+ (this.props.marca?this.props.marca:null) +')'}
                          fullWidth
                          maxLength='100'
                          value={this.state.filters.marca}
                          onChange={this.handleInputChange}
                          variant="standard"
              />
            </Box>
            <Box p={1}>
              <TextField  name='modelo'
                          id='modelo'
                          label={'Modelo (Valor ficha: '+ (this.props.modelo?this.props.modelo:null) +')'}
                          placeholder={'Modelo (Valor ficha: '+ (this.props.modelo?this.props.modelo:null) +')'}
                          fullWidth
                          maxLength='100'
                          value={this.state.filters.modelo}
                          onChange={this.handleInputChange}
                          variant="standard"
              />
              { 'modelo_completo' in this.props &&
              <Button size='small' onClick={this.handleTraspasarModelo}>
                Incluir Modelo completo: '{this.props.modelo_completo}'
              </Button>
              }
            </Box>
            <Box p={1}>
              <TextField  name='agno'
                          id='agno'
                          label={'Año (Valor ficha: '+ (this.props.agno?this.props.agno:null) +')'}
                          placeholder={'Año (Valor ficha: '+ (this.props.agno?this.props.agno:null) +')'}
                          fullWidth
                          maxLength='4'
                          value={this.state.filters.agno}
                          onChange={this.handleInputChange}
                          variant="standard"
              />
            </Box>
            <Box>
              <Button startIcon={<SearchIcon/>} onClick={this.handleLoad}>
                Filtrar
              </Button>
            </Box>
          </Box>



          <Box>

            {this.state.objects.length>0 && this.state.html.list &&
            <Box p={1}>
              <TablePagination
                labelRowsPerPage='Resultados por página'
                component="div"
                count={this.state.pagination.rows_num}
                page={this.state.pagination.page}
                onPageChange={this.handleChangePage}
                rowsPerPage={this.state.pagination.rows_per_page}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
              />
              <TableContainer>
                <Table size="small" >
                  <EnhancedTableHead
                    order={this.state.sorting.order}
                    orderBy={this.state.sorting.order_by}
                    onRequestSort={this.handleSort}
                  />
                  <TableBody>
                  {this.state.objects.map((object) => {
                    return(
                      <TableRow key={object.id}>
                        <TableCell>
                          <Button onClick={(event) => this.props.handleImportSii(object.id, this.props.current_index)}
                                  startIcon={<SystemUpdateAltIcon/>}
                                  size='small'
                                  >
                            &nbsp;
                          </Button>
                        </TableCell>
                        <TableCell>
                          {object.marca}
                        </TableCell>
                        <TableCell>
                          {object.modelo}
                        </TableCell>
                        <TableCell>
                          {object.version}
                        </TableCell>
                        <TableCell>
                          {object.cilindrada}
                        </TableCell>
                        <TableCell>
                          {object.equipamiento}
                        </TableCell>
                        <TableCell>
                          {object.equipamiento_detalle}
                        </TableCell>
                        <TableCell>
                          {object.agno}
                        </TableCell>
                        <TableCell>
                          {object.tasacion}
                        </TableCell>
                        <TableCell>
                          {object.permiso}
                        </TableCell>
                      </TableRow>
                    )
                  })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            }
            {this.state.objects.length===0 && !this.state.html.list &&
            <Alert severity='warning'>
              No se encontraron vehículos
            </Alert>
            }
          </Box>
          
        </Box>
    );
  }
}

export default VehiculoSii;
